import { CognitoIdentityProviderClient, InitiateAuthCommand } from "@aws-sdk/client-cognito-identity-provider";
import useAuth from "./useAuth";

const useRefreshToken = () => {
    const { auth, setAuth } = useAuth();

    const refresh = async () => {
        try {
            const client = new CognitoIdentityProviderClient({region: process.env.REACT_APP_COGNITO_AWS_REGION});
            const input = { 
                "AuthFlow": "REFRESH_TOKEN",
                "ClientId": process.env.REACT_APP_COGNITO_CLIENT_ID,
                "AuthParameters": {
                    "REFRESH_TOKEN": auth.refreshToken
                }
            }
            const command = new InitiateAuthCommand(input);
            const response = await client.send(command);
            setAuth(prev => {
                return {    ...prev,
                            accessToken: response.AuthenticationResult.AccessToken,
                            idToken: response.AuthenticationResult.IdToken }
            });
            return response.AuthenticationResult.AccessToken;
        } catch (err) {
            console.error(err);
        }
    }
    return refresh;
};

export default useRefreshToken;
